import { Zap } from "lucide-react";

const ITEMS = ["Sem hospedagem", "Sem DNS", "Sem cPanel", "Sem código", "Publicado em 3 min", "HTML do ChatGPT", "HTML do Claude", "Editor clique-e-edite", "SSL + CDN inclusos", "Domínio próprio"];

export const Marquee = () => (
  <div data-testid="marquee" className="relative bg-[var(--ink)] text-white py-6 overflow-hidden -rotate-1 my-10">
    <div className="marquee-track">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center gap-8 pr-8 font-display font-semibold text-2xl sm:text-3xl tracking-tight whitespace-nowrap">
          {t} <Zap size={20} className="text-[var(--orange)] fill-[var(--orange)]" />
        </span>
      ))}
    </div>
  </div>
);
